/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerBlender('verticalhorizontalblur', function (imgData, background, cb) {
    var tmpCanvas = document.createElement('canvas'), ctx,
        image = document.createElement('canvas');

    image.width = imgData.width;
    image.height = imgData.height;
    tmpCanvas.width = imgData.width;
    tmpCanvas.height = imgData.height;

    var px = imgData.data;

    var j = 0;
    var i = 0;
    var length = px.length;
    var tmpPx;

    for (j = 0; j < 1; j++){
        tmpPx = px.slice();

        for (i = 0; i < length; i++){
            if (i % 4 === 3 ) {continue;}

            px[i] = (tmpPx[i]
            + (tmpPx[i - 4] || tmpPx[i])
            + (tmpPx[i + 4] || tmpPx[i])
            + (tmpPx[i - 4 * 2] || tmpPx[i])
            + (tmpPx[i + 4 * 2] || tmpPx[i])
            ) / 5;
        }
        j++;
    }

    for (j = 0; j < 1; j++){
        tmpPx = px.slice();

        for (i = 0; i < length; i++){
            if (i % 4 === 3 ) {continue;}

            px[i] = (tmpPx[i]
            + (tmpPx[i - 4 * imgData.width] || tmpPx[i])
            + (tmpPx[i + 4 * imgData.width] || tmpPx[i])
            + (tmpPx[i - 4 * 2 * imgData.width] || tmpPx[i])
            + (tmpPx[i + 4 * 2 * imgData.width] || tmpPx[i])
            ) / 5;
        }
        j++;
    }

    image.getContext('2d').putImageData(imgData, 0, 0);

    ctx = tmpCanvas.getContext('2d');

    ctx.globalCompositeOperation = 'source-over'; // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation

    ctx.drawImage(background, 0, 0);
    ctx.drawImage(image, 0, 0);

    cb(ctx.getImageData(0, 0, imgData.width, imgData.height));
  });
}(FakeCation));
